import { useEffect, useState } from 'react';
import { SEOHead } from '../components/seo/SEOHead';
import { HeroSection } from '../components/home/HeroSection';
import { BusinessIntro } from '../components/home/BusinessIntro';
import { ServicesGrid } from '../components/home/ServicesGrid';
import { WhyChooseUs } from '../components/home/WhyChooseUs';
import { ProcessFlow } from '../components/home/ProcessFlow';
import { IndustriesServed } from '../components/home/IndustriesServed';
import { Testimonials } from '../components/home/Testimonials';
import { StatsCounter } from '../components/home/StatsCounter';
import { FAQAccordion } from '../components/home/FAQAccordion';
import { CTABanner } from '../components/home/CTABanner';
import { ContactMap } from '../components/home/ContactMap';
import { api } from '../lib/api';
import { buildLocalBusinessSchema, buildFaqSchema } from '../lib/seo-utils';
import type { FAQ } from '@bharat-consultancy/shared';

export default function Home() {
  const [faqs, setFaqs] = useState<FAQ[]>([]);

  useEffect(() => {
    api.services
      .globalFaqs()
      .then((res) => setFaqs(res.faqs))
      .catch(() => {
        // Non-critical content (homepage FAQ section) — fail silently
        // rather than breaking the whole page if this one fetch errors.
      });
  }, []);

  return (
    <>
      {/* Title/description below follow the client's "SEO HOME PAGE"
          content doc (60-char title, 160-char meta description). The
          previous copy was scoped to Purulia only; the client's
          business now positions itself as a PAN-India service, so
          areaServed and copy are widened accordingly rather than
          keeping the old Purulia-only framing. */}
      <SEOHead
        title="Bharat Consultancy | Business Registration, GST, Income Tax & Compliance"
        description="Bharat Consultancy provides GST, Income Tax, Accounting, Company Compliance, EPFO, ESIC, Trademark, Project Reports and Business Registration."
        canonicalPath="/"
        jsonLd={[
          buildLocalBusinessSchema({
            name: 'Bharat Consultancy',
            address: '2nd Floor, Aradhya Complex, SN Sarkar St, Munsifdanga, Purulia, West Bengal 723101',
            phone: '+918170896296',
            url: 'https://bharat-consultancy.com',
            areaServed: ['India'],
          }),
          ...(faqs.length ? [buildFaqSchema(faqs)] : []),
        ]}
      />
      <HeroSection />
      <BusinessIntro />
      <ServicesGrid />
      <WhyChooseUs />
      <ProcessFlow />
      <IndustriesServed />
      <Testimonials />
      <StatsCounter />
      <FAQAccordion faqs={faqs} />
      <CTABanner />
      <ContactMap />
    </>
  );
}
